export const DEFAULT_NUMBER_OF_FUTURES_FEE: number = 9999;
